//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/logo.svg';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
import CloseButton from '~/components/atoms/CloseButton.vue';
export default {
  name: 'LayerFullscreen',
  components: {
    MdmIcon: MdmIcon,
    CloseButton: CloseButton
  }
};